// angular
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
// interfaces
import {
  IHelpData,
  IHelpDataResponse,
  IHelpTopic,
} from '@app/+help/shared/interfaces/help-data.interface';

@Injectable()
export class HelpService {
  // states
  public helpsData = signal<IHelpData[]>([]);
  public isHelpsDataLoading = signal<boolean>(false);
  public helpsDataCount = signal<number>(0);

  public helpDetails = signal<IHelpData | null>(null);
  public isHelpDetailsLoading = signal<boolean>(false);

  public helpTopics = signal<IHelpTopic[]>([]);
  public isHelpTopicsLoading = signal<boolean>(false);

  // dependencies
  private readonly _httpClient = inject(HttpClient);
  constructor() {}

  // get helps list data
  public getHelpData() {
    // set loading state
    this.isHelpsDataLoading.set(true);

    return this._httpClient.get<IHelpDataResponse>(`main/help`).subscribe({
      next: (res) => {
        // set helps list data
        this.helpsData.set(res?.data);
        // set helps data count
        this.helpsDataCount.set(res?.count);
      },
      error: () => this.isHelpsDataLoading.set(false),
      complete: () => this.isHelpsDataLoading.set(false),
    });
  }

  // get help details data by id
  public getHelpDetailsData(id: string) {
    // set loading state
    this.isHelpDetailsLoading.set(true);

    return this._httpClient.get<IHelpData>(`main/help/${id}`).subscribe({
      next: (res) => {
        // set help details data
        this.helpDetails.set(res);
      },
      error: () => this.isHelpDetailsLoading.set(false),
      complete: () => this.isHelpDetailsLoading.set(false),
    });
  }

  // get topics data
  public getHelpTopics() {
    // set loading state
    this.isHelpTopicsLoading.set(true);

    return this._httpClient.get<IHelpTopic[]>(`main/topic`).subscribe({
      next: (res) => {
        // set help topics data
        this.helpTopics.set(res);
      },
      error: () => this.isHelpTopicsLoading.set(false),
      complete: () => this.isHelpTopicsLoading.set(false),
    });
  }
}
